class VideoCarouselRecommend extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector("[data-swiper]");
    this.swiper = null;
  }

  connectedCallback() {
    // this.swiper = new Swiper(this.swiperEl, {
    //   slidesPerView : "5",
    //   loop: true,
    //   centeredSlides: true,
    //   spaceBetween: 20,
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //   on: {
    //     transitionEnd: () => {
    //       this.handleActive();
    //     },
    //   },
    // });
    this.initSwiper();
    this.handleActive();
    window.addEventListener("resize", () => {
      // 添加防抖减少重复计算
      clearTimeout(window.resizeTimer);
      window.resizeTimer = setTimeout(this.initSwiper.bind(this), 100);
    });

    this.querySelectorAll(".video-carousel-recommend--item-video-inner").forEach((videoWrapper) => {
      const video = videoWrapper.querySelector("video");
      videoWrapper.querySelector(".video-mute-button").addEventListener("click",()=>{
        // this.toggleMuteVideo(video, videoWrapper);
        this.toggleMuteAllVideo();
      })
    });
  }

  toggleMuteAllVideo() {
    this.querySelectorAll(".video-carousel-recommend--item-video-inner").forEach((videoWrapper) => {
      const video = videoWrapper.querySelector("video");
      this.toggleMuteVideo(video, videoWrapper);
    });
  }
toggleMuteVideo(video, videoWrapper) {
  video.muted = !video.muted;
  videoWrapper.querySelector(".video-mute-button").classList.toggle("mute", video.muted);
  
}
muteVideo(video, videoWrapper) {
  video.muted = true;
  videoWrapper.querySelector(".video-mute-button").classList.toggle("mute", video.muted);
  
}
  initSwiper() {
    const SPACE_BETWEEN = 0;
    let SLIDE_WIDTH = 304;
    const CENTERED_WIDTH = 340;
    const CENTERED_OFFSEST = CENTERED_WIDTH / SLIDE_WIDTH;
    let add = 0.1;
    if(window.innerWidth < 767) {
      SLIDE_WIDTH = 250;
      add = 0;
    }
    // 清除旧实例
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }

    // 计算父容器可用宽度
    const parentWidth = this.swiperEl.offsetWidth;

    // 计算可显示的幻灯片数量

    // const visibleSlides = Math.max(
    //   1+CENTERED_OFFSEST,
    //   Number.parseFloat(
    //     (parentWidth - (CENTERED_WIDTH)) / (SLIDE_WIDTH + SPACE_BETWEEN)
    //   ).toFixed(2)
    // );
    const visibleSlides = Math.max(
      1.5,
      Number.parseFloat(
        (parentWidth + SPACE_BETWEEN) / (SLIDE_WIDTH + SPACE_BETWEEN) + add
      ).toFixed(3)
    );
    console.log("visibleSlides", visibleSlides, "parentWidth", parentWidth);
    // 初始化Swiper
    this.swiper = new Swiper(this.swiperEl, {
      spaceBetween: SPACE_BETWEEN,
      slidesPerView: visibleSlides,
      slidesPerGroup: 1,
      centeredSlides: true,
      loop: true,
      speed: 500,
      slideToClickedSlide: true,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar") 
      },
      on: {
        transitionEnd: () => {
          this.handleActive();
        },
      },
    });
  }
  handleActive() {
    console.log("handle active");
    this.querySelectorAll(".video-carousel-recommend--item-video-inner").forEach((videoWrapper) => {
      const video = videoWrapper.querySelector("video");
      // this.muteVideo(video, videoWrapper);
      video.pause();
    });
    this.querySelector(".swiper-slide-active").querySelector("video").play();
  }
}

if (!customElements.get("video-carousel-recommend")) {
  customElements.define("video-carousel-recommend", VideoCarouselRecommend);
}
